import React from 'react';
import { Skeleton } from 'primereact/skeleton';

const SkeletonLoader = () => {
  return (
    <div className="w-100">
      <div className="d-flex justify-content-center mb-3">
        <Skeleton width="30%" height="1.5rem" className="mb-1" />
      </div>
      <div className="d-flex justify-content-center mb-3">
        <Skeleton width="75%" height="1.8rem" className="mb-1" />
      </div>
      <hr style={{ color: 'lightgrey' }} />
      <div className="mb-4">
        <Skeleton width="10rem" height="1rem" className="mb-1" />
        <Skeleton width="100%" height="2.5rem" />
      </div>

      <div className="mb-4">
        <Skeleton width="8rem" height="1rem" className="mb-1" />
        <div className="d-flex" style={{ gap: '1rem' }}>
          <Skeleton width="100%" height="2.5rem" />
          <Skeleton width="100%" height="2.5rem" />
          <Skeleton width="100%" height="2.5rem" />
        </div>
      </div>

      <div className="mb-4">
        <Skeleton width="10rem" height="1rem" className="mb-1" />
        <Skeleton width="100%" height="2.5rem" />
      </div>

      <div className="mb-4">
        <Skeleton width="8rem" height="1rem" className="mb-1" />
        <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}>
          <Skeleton width="50%" height="2.5rem" />
          <Skeleton width="50%" height="2.5rem" />
        </div>
        <div style={{ display: 'flex', gap: '1rem' }}>
          <Skeleton width="25%" height="2.5rem" />
          <Skeleton width="75%" height="2.5rem" />
        </div>
      </div>

      <div className="mb-4">
        <Skeleton width="8rem" height="1rem" className="mb-1" />
        <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}>
          <Skeleton width="50%" height="2.5rem" />
          <Skeleton width="50%" height="2.5rem" />
        </div>
        <div style={{ display: 'flex', gap: '1rem' }}>
          <Skeleton width="25%" height="2.5rem" />
          <Skeleton width="75%" height="2.5rem" />
        </div>
      </div>
      <div className="mb-4">
        <Skeleton width="10rem" height="1rem" className="mb-1" />
        <Skeleton width="100%" height="2.5rem" />
      </div>
      <hr style={{ color: 'lightgrey' }} />
      <div className="mb-4 d-flex justify-content-end">
        <Skeleton width="6rem" height="2.5rem" />
      </div>
    </div>
  );
};

export default SkeletonLoader;
